var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        [
          _c(
            "a-row",
            { attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 3 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽检市级"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 15 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽检区县级选择"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 2 } }, [
                _c("span", { staticClass: "list-header" }, [_vm._v("总数")]),
              ]),
              _c("a-col", { attrs: { span: 4 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("检测机构"),
                ]),
              ]),
            ],
            1
          ),
          _vm._l(_vm.localValue, function (task) {
            return !_vm.disabled || task.execDept
              ? _c(
                  "a-row",
                  { style: { margin: "4px" }, attrs: { gutter: 4 } },
                  [
                    _c(
                      "a-col",
                      [
                        !_vm.disabled || task.execDept
                          ? _c(
                              "a-row",
                              [
                                _c("a-col", { attrs: { span: 3 } }, [
                                  _c("div", { staticClass: "box" }, [
                                    _vm._v(_vm._s(task.regionName)),
                                  ]),
                                ]),
                                _c("a-col", { attrs: { span: 15 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "box",
                                      staticStyle: {
                                        "text-align": "left",
                                        "line-height": "30px",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-row",
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { span: "22" } },
                                            [
                                              _vm._l(
                                                task.monitTaskRegionList,
                                                function (
                                                  monitTaskRegion,
                                                  index
                                                ) {
                                                  return _c(
                                                    "a-tag",
                                                    {
                                                      key: index,
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "super",
                                                      },
                                                    },
                                                    [
                                                      !_vm.disabled
                                                        ? [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  monitTaskRegion.regionName +
                                                                    "-" +
                                                                    monitTaskRegion.pickCount
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  cursor:
                                                                    "pointer",
                                                                  "font-size":
                                                                    "14px",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removemonitTaskRegionList(
                                                                        task,
                                                                        monitTaskRegion
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("×")]
                                                            ),
                                                          ]
                                                        : [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  monitTaskRegion.regionName +
                                                                    "(" +
                                                                    monitTaskRegion.pickCount +
                                                                    ")"
                                                                ) +
                                                                " "
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              _c("div", {
                                                staticStyle: {
                                                  display: "inline-block",
                                                  height: "30px",
                                                  width: "1px",
                                                },
                                              }),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { span: "2" } },
                                            [
                                              !_vm.disabled
                                                ? _c("a-icon", {
                                                    attrs: {
                                                      type: "plus-circle",
                                                      theme: "twoTone",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addmonitTaskRegionList(
                                                          task
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("a-col", { attrs: { span: 2 } }, [
                                  _c("div", { staticClass: "box" }, [
                                    _vm._v(" " + _vm._s(task.total) + " "),
                                  ]),
                                ]),
                                _c(
                                  "a-col",
                                  { attrs: { span: 4 } },
                                  [
                                    _c("a-ext-gov-select", {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: task.execDept,
                                        callback: function ($$v) {
                                          _vm.$set(task, "execDept", $$v)
                                        },
                                        expression: "task.execDept",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e()
          }),
          _c(
            "a-row",
            { style: { margin: "4px" }, attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 18 } }),
              _c("a-col", { attrs: { span: 2 } }, [
                !_vm.disabled
                  ? _c("div", { staticClass: "total-box" }, [
                      _vm._v(" 总数量："),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.total)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _c("a-col", { attrs: { span: 4 } }),
            ],
            1
          ),
        ],
        2
      ),
      _vm.modalVisable
        ? _c("check-target-picker-modal", {
            attrs: { visible: _vm.modalVisable, param: _vm.modalParam },
            on: {
              "update:visible": function ($event) {
                _vm.modalVisable = $event
              },
              dialogBack: _vm.onModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("地区及机构")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }